module.exports = process.env.PROMISE_QUEUE_COVERAGE ?
    require('./lib-cov') :
    require('./lib');



//////////////////
// WEBPACK FOOTER
// ./~/promise-queue/index.js
// module id = 371
// module chunks = 0